<template>
  <v-tab @click="$emit('click',$event)">
    <i :class="icone+' pr-1'" v-if="icone"></i>
    <slot />
  </v-tab>
</template>

<script>
export default {
  name: "EdTabsPanel",
  mixins: [],
  components: {},
  props: {
    icone:{
      type:String,
      default:null
    }
  },
  data() {
    return {};
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/components/template/EdTabsPanel.vue